<table class="selectableTable">
  <tr>
    <th class="sortable" (click)="sortBy_click('transactionDate')">
      Transaction Date
    </th>
    <th class="sortable">Funding Date</th>
    <th class="sortable">DBA</th>
    <th class="sortable">Processor</th>
    <th class="sortable">Case #</th>
    <th class="sortable">Payment Ref.</th>
    <th class="sortable">Transaction Amt.</th>
    <th class="sortable">Chargeback Amt.</th>
    <th class="sortable">Reason Code</th>
    <th class="sortable">Reason Details</th>
    <th class="sortable">Status</th>
  </tr>
  @for (
    item of this.dataSource.data;
    track item.id;
    let even = $even;
    let odd = $odd
  ) {
    <tr
      [ngClass]="{ even: even, odd: odd }"
      class="rowSummary highlightable"
      (click)="_selectRow_click(item.id)"
    >
      <td>{{ item.transactionDate }}</td>
      <td>{{ item.actionDate }}</td>
      <td>{{ item.dba }}</td>
      <td>{{ item.processor }}</td>
      <td>{{ item.caseNumber }}</td>
      <td>{{ item.paymentReference }}</td>
      <td>{{ item.transactionAmount }}</td>
      <td>{{ item.chargebackAmount }}</td>
      <td>{{ item.reasonCode }}</td>
      <td>{{ item.reasonDetails }}</td>
      <td>{{ item.status }}</td>
    </tr>
  }
</table>
